import dom from "../../../../common/ts/core/dom";

import {
    FILTER_NAMES,
    FILTERS_BAR_FORM_SELECTOR,
    FILTERS_MODAL_FORM_SELECTOR,
    FILTERS_SERP_SUGGESTION_FORM_SELECTOR
} from "../../../../common/ts/serp/filters/constants";
import {FiltersParams} from "../../../../common/ts/core/filters/GetNumberOfListingsAjax";


export default function filterFormData(formSelectors: string[]) {
    return formSelectors.reduce(
        (acc, formSelector) =>
            ({...acc, ...dom.getFormDataMultiSelection(formSelector)}),
        {}
    )
}

export function getFormDataSubmittingInFilterBar() {
    return filterFormData([FILTERS_MODAL_FORM_SELECTOR, FILTERS_BAR_FORM_SELECTOR, FILTERS_SERP_SUGGESTION_FORM_SELECTOR]);
}


export function getFormDataSubmittingFromFiltersModal() {
    return filterFormData([FILTERS_BAR_FORM_SELECTOR, FILTERS_MODAL_FORM_SELECTOR]);
}

export function getTrackingFormData(
    formData: { [p: string]: any },
    currentSearchParams: URLSearchParams,
) {
    const parsedFormData: { [key: string]: string } = {};
    const filters = Object.values(FILTER_NAMES)

    filters.forEach((key) => {
        if (formData[key] && formData[key] !== currentSearchParams.get(key)) {
            parsedFormData[key] = formData[key];
        }
    });

    return parsedFormData
}

export function userSearchFormData(buttonId: string): FiltersParams {
    const formData: { [p: string]: any } = new FormData(dom.select(FILTERS_MODAL_FORM_SELECTOR) as HTMLFormElement);
    return {
        buttonId: buttonId,
        geoId: formData.get(FILTER_NAMES.GEO_ID),
        geoChildrenId: formData.get(FILTER_NAMES.GEO_CHILDREN_ID),
        roomsMin: formData.get(FILTER_NAMES.MIN_BEDROOMS),
        roomsMax: formData.get(FILTER_NAMES.MIN_BEDROOMS),
        bathRoomsMin: formData.get(FILTER_NAMES.MIN_BATHROOMS),
        bathRoomsMax: formData.get(FILTER_NAMES.MIN_BATHROOMS),
        priceMin: formData.get(FILTER_NAMES.MIN_PRICE),
        priceMax: formData.get(FILTER_NAMES.MAX_PRICE),
        areaMin: formData.get(FILTER_NAMES.MIN_AREA),
        areaMax: formData.get(FILTER_NAMES.MAX_AREA),
        propertyTypes: formData.get(FILTER_NAMES.PROPERTY_TYPE),
        amenities: formData.get(FILTER_NAMES.AMENITIES),
        operationType: formData.get(FILTER_NAMES.OPERATION_TYPE),
        type: formData.get(FILTER_NAMES.TYPE),
        sorting: formData.get(FILTER_NAMES.SORTING),
        freeText: formData.get(FILTER_NAMES.FREE_TEXT),
        daysSincePublication: formData.get(FILTER_NAMES.DAYS_SINCE_PUBLICATION),
        bankProperty: formData.get(FILTER_NAMES.BANK_PROPERTY),
        furnished: formData.get(FILTER_NAMES.FURNISHED),
        stratum: formData.get(FILTER_NAMES.STRATUM),
        nearbyPoiTypeDistance: formData.get(FILTER_NAMES.NEARBY_POI_TYPE_DISTANCE)
    } as FiltersParams
}
